export function SyncBadge({
  status,
  label,
}: {
  status: 'new' | 'changed' | 'unchanged' | 'archived_upstream' | 'invalid' | 'conflict' | 'missing_upstream' | string;
  label?: string;
}): JSX.Element {
  const tone =
    status === 'new'
      ? 'new'
      : status === 'changed' || status === 'conflict'
        ? 'changed'
        : status === 'archived_upstream'
          ? 'archived'
          : status === 'invalid'
            ? 'invalid'
            : 'neutral';
  return (
    <span className={`sync-badge sync-badge--${tone}`}>
      {label ?? status.replace(/_/g, ' ')}
    </span>
  );
}
